import { cn } from '../../lib/utils'

/** 设备健康度条（电池/信号） */
export function HealthBar({ value, max = 100, warnBelow, className }: {
  value?: number | null
  max?: number
  warnBelow?: number
  className?: string
}) {
  if (value == null) return <span className="text-xs text-muted-foreground">—</span>
  const pct = Math.max(0, Math.min(100, (value / max) * 100))
  const warn = warnBelow != null && value < warnBelow
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="h-1.5 w-16 overflow-hidden rounded-full bg-foreground/10">
        <div
          className={cn('h-full rounded-full', warn ? 'bg-warning' : 'bg-success')}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className={cn('font-mono text-[11px] tabular-nums', warn ? 'text-warning' : 'text-muted-foreground')}>
        {Math.round(value)}%
      </span>
    </div>
  )
}

/** 信号强度（dBm）转格子 */
export function SignalBars({ dbm }: { dbm?: number | null }) {
  if (dbm == null) return <span className="text-xs text-muted-foreground">—</span>
  // 经验映射：>= -60 满格，<= -100 无格
  const bars = dbm >= -60 ? 4 : dbm >= -72 ? 3 : dbm >= -85 ? 2 : dbm >= -100 ? 1 : 0
  return (
    <span className="inline-flex items-end gap-0.5" title={`${dbm} dBm`}>
      {[1, 2, 3, 4].map((i) => (
        <span
          key={i}
          className={cn('w-1 rounded-sm', i <= bars ? 'bg-primary' : 'bg-foreground/15')}
          style={{ height: `${3 + i * 2.5}px` }}
        />
      ))}
    </span>
  )
}
